import React from 'react';
import ListView from './ListView';
export default function Customers(){
  return <ListView icon="customers" title="Customers" subtitle="Top-level tenants — agencies or companies using the platform." path="/customers" columns={["id","external_id","name"]} mapRow={r=>r} queryParam="name"/>;
}
